import { FaLock, FaLockOpen } from "react-icons/fa";

const FloatingLockToggle = ({ sectionName, isLocked, onToggle }) => {
  if (!sectionName) {
    return null;
  }

  return (
    <div className="flex items-center justify-end gap-3 px-9 py-3 bg-gray-50 border-b border-[#D3D3D3]">
      <div className="flex items-center gap-2">
        {isLocked ? (
          <FaLock className="text-red-600" />
        ) : (
          <FaLockOpen className="text-green-600" />
        )}
        <span className="text-sm text-gray-700">
          La section <strong>{sectionName}</strong> est{" "}
          <span
            className={`font-bold ${isLocked ? "text-red-600" : "text-green-600"}`}
          >
            {isLocked ? "verrouillée" : "déverrouillée"}
          </span>
        </span>
      </div>

      <div className="flex items-center gap-2">
        <div
          className={`w-[50px] h-[25px] rounded-full relative cursor-pointer transition-colors ${
            isLocked ? "bg-gray-700" : "bg-green-500"
          }`}
          onClick={onToggle}
        >
          <div
            className="w-5 h-5 bg-white rounded-full absolute top-1/2 transform -translate-y-1/2 transition-all duration-300"
            style={{
              left: isLocked ? "5px" : "25px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default FloatingLockToggle;
